import { browserApi } from 'lib/httpClient';
import { Owners } from 'owners';
import { ProducerDataResponse } from 'producerData';

export interface ProducerDataParams {
  eventId: string;
  owner: Owners;
}
export async function getProducerDataBff({
  eventId,
  owner
}: ProducerDataParams) {
  const { data } = await browserApi.get<ProducerDataResponse>(
    '/producer-data',
    {
      params: { eventId, owner }
    }
  );
  return data;
}
